<template>
  <div class="creds-selection" v-bind:class="{ 'disabled': disabled }">
    <div class="description border-bottom">
      <div class="title">{{ title }}</div>
    </div>
    <div class="border-bottom">
      <source-selection
        :disabled="disabled"
        :selectionText="selectionText"
        :sources="sources"
        :scrollable="scrollable"
        :addSource="addSource">
      </source-selection>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import { mapState } from 'vuex';

import SourceSelection from './SourceSelection.vue';

export default {
  name: 'AddMissingCredentialsCard',
  components: {
    SourceSelection,
  },
  data() {
    return {
      collapsed: false,
    };
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    scrollable: Boolean,
    sourceType: String,
    selectionText: String,
    title: String,
    addSource: Function,
  },
  computed: {
    ...mapState('sourceFields', ['allSourceFields']),
    sourceTypes() {
      return {
        CARD: 'card',
        BANK: 'bank',
      };
    },
    sources() {
      if (this.sourceType === this.sourceTypes.CARD) {
        return _.filter(this.allSourceFields, source => source.type === this.sourceTypes.CARD && !source.hidden);
      }
      return _.filter(this.allSourceFields, source => source.type === this.sourceTypes.BANK && !source.hidden);
    },
  },
  methods: {
    clickFinished() {
      this.collapsed = true;
      this.action();
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../../node_modules/base-ui/src/scss/riseup-colors';
  @import '../../../scss/mixins';

  .creds-selection {
    @include card;

    .description {
      padding: 18px 30px 22px 15px;

      .title {
        @include card-title;
      }
    }

    .border-bottom {
      border-bottom: solid 1px $riseup_gray_0;
    }
  }

  .disabled {
    .description {
      color: $riseup_gray_1;
    }
  }

</style>
